import styled from "styled-components";

export const SectionContainer = styled.section`
  max-width: 1280px;

  margin: 130px auto;
  padding: 0 32px;
  width: 100%;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 48px;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    margin: 88px auto;
    padding: 0 16px;
  }
`;

export const SectionContent = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 585px;
  padding: 32px 0;
  gap: 88px;

  @media (max-width: 1024px) {
    max-width: initial;
  }

  @media (max-width: 768px) {
    gap: 72px;
  }
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 32px;
  justify-items: start;

  @media (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 585px;

  @media (max-width: 1024px) {
    max-width: initial;
  }
`;
